import { Box, useTheme } from '@mui/material';
import { Image } from '@realadvisor/image';
import { House } from 'lucide-react';

type DashboardPropertyThumbnailProps = {
  imageUrl: string | null;
};

export const DashboardPropertyThumbnail = ({
  imageUrl,
}: DashboardPropertyThumbnailProps) => {
  const theme = useTheme();
  const palette = (theme.vars ?? theme).palette;

  return (
    <Box sx={{ pr: 2, overflow: 'hidden' }}>
      <Box
        sx={{
          width: 64,
          height: 64,
          borderTopLeftRadius: 2,
          borderBottomLeftRadius: 2,
          backgroundColor: palette.grey[200],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {imageUrl ? (
          <Image
            src={imageUrl}
            css={{
              width: 64,
              height: 64,
              objectFit: 'cover',
            }}
            options={{ w: 256, h: 256, f: 'jpg' }}
          />
        ) : (
          <House size={24} strokeWidth={1.5} color={palette.grey[400]} />
        )}
      </Box>
    </Box>
  );
};
